export default function trim(s: string): string {
    if (!s) return s;
    return s ? s.trim().replace(/[:.;\s]+$/g, "") : s;
}
